import {CreateCatchupVodRequest} from 'src/app/model/cms-vod-core/catchup-models/create-catchup-vod-request';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {CatchupCreateRequest} from 'src/app/model/catchup-controller/catchup-create-request.model';
import {Program} from 'src/app/model/cms-btv-core/program-model';
import {Catchup} from 'src/app/model/cms-vod-core/catchup-models/catchup-model';
import {CatchupNote} from 'src/app/model/cms-vod-core/catchup-models/catchup-note';
import {CensorshipPreview} from 'src/app/model/censorship-preview.model';
import {LanguageOption} from 'src/app/model/language-option.model';
import {LanguageOptionsRequest} from 'src/app/model/language-options-request.model';
import {CatchupTrimRequest} from 'src/app/model/cms-vod-core/catchup-models/catchup-trim-request.model';
import {PageOfCatchupNote} from 'src/app/model/cms-vod-core/catchup-models/page-of-catchup-note';
import {PageOfCatchup} from 'src/app/model/cms-vod-core/catchup-models/page-of-catchup.model';
import {
  PageOfNotApprovedCatchupResponse
} from 'src/app/model/cms-vod-core/catchup-models/page-of-not-approved-catchup.model';
import {ContentMetadataHistory} from 'src/app/model/cms-vod-core/content-controller/content-medatada-history.model';
import {ParentChangePrecheck} from 'src/app/model/cms-vod-core/content-controller/parent-change-precheck.model';
import {ContentSectionInfoRequest} from 'src/app/model/cms-vod-core/content-controller/content-section-info-request.model';
import {StatusLog} from 'src/app/model/cms-vod-core/status-log.model';
import {
  ValidationEventsPlatformComment
} from 'src/app/model/cms-vod-core/validation-event-models/validation-events-platform-comment.model';

import {QueryParams} from 'src/app/model/query-models/query-models';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CatchupService {
  private readonly catchupApiUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.CATCHUP;
  private catchupDeletedSource = new Subject<void>();
  catchupDeleted$ = this.catchupDeletedSource.asObservable();
  static page: number = 1;

  constructor(private http: HttpClient) {
  }

  getAllCatchUp(catchupQueryParams?: QueryParams): Observable<PageOfCatchup> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (catchupQueryParams.channelName) {
      queryParams = queryParams.set('channelName', <any>catchupQueryParams.channelName);
    }

    if (catchupQueryParams.releaseDate) {
      queryParams = queryParams.set('releaseDate', <any>catchupQueryParams.releaseDate);
    }

    if (catchupQueryParams.statuses && catchupQueryParams.statuses.length > 0) {
      queryParams = queryParams.set('status', <any>catchupQueryParams.statuses);
    }

    catchupQueryParams.page = catchupQueryParams.page - 1;
    if (catchupQueryParams.page >= 0) {
      queryParams = queryParams.set('page', <any>catchupQueryParams.page);
    }

    if (catchupQueryParams.type) {
      queryParams = queryParams.set('type', <any>catchupQueryParams.type);
    }

    if (catchupQueryParams.itemCount) {
      queryParams = queryParams.set('itemCount', <any>catchupQueryParams.itemCount);
    }

    if (catchupQueryParams.name) {
      queryParams = queryParams.set('name', <any>catchupQueryParams.name);
    }

    if (catchupQueryParams.endTime) {
      queryParams = queryParams.set('endTime', <any>catchupQueryParams.endTime);
    }

    if (catchupQueryParams.trimmed != null || undefined) {
      queryParams = queryParams.set('trimmed', <any>catchupQueryParams.trimmed);
    }
    if (catchupQueryParams.mwInternalCode) {
      queryParams = queryParams.set('mwInternalCode', <any>catchupQueryParams.mwInternalCode);
    }
    if (catchupQueryParams.guid) {
      queryParams = queryParams.set('guid', <any>catchupQueryParams.guid);
    }
    if (catchupQueryParams.status) {
      queryParams = queryParams.set('status', <any>catchupQueryParams.status);
    }
    if (catchupQueryParams.sortParam) {
      queryParams = queryParams.set('sortParam', <any>catchupQueryParams.sortParam);
    }
    if (catchupQueryParams.planStartTime) {
      queryParams = queryParams.set('planStartTime', <any>catchupQueryParams.planStartTime);
    }
    if (catchupQueryParams.planEndTime) {
      queryParams = queryParams.set('planEndTime', <any>catchupQueryParams.planEndTime);
    }
    if (catchupQueryParams.genreId) {
      queryParams = queryParams.set('genreId', <any>catchupQueryParams.genreId);
    }
    if (catchupQueryParams.seriesName) {
      queryParams = queryParams.set('seriesName', <any>catchupQueryParams.seriesName);
    }
    if (catchupQueryParams.seasonNo) {
      queryParams = queryParams.set('seasonNo', <any>catchupQueryParams.seasonNo);
    }
    if (catchupQueryParams.episodeNo) {
      queryParams = queryParams.set('episodeNo', <any>catchupQueryParams.episodeNo);
    }
    return this.http.get<PageOfCatchup>(this.catchupApiUrl, {params: queryParams});
  }

  getAllCatchupWithPlanProfiles(catchupQueryParams?: QueryParams): Observable<PageOfCatchup> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (catchupQueryParams.channelName) {
      queryParams = queryParams.set('channelName', <any>catchupQueryParams.channelName);
    }

    catchupQueryParams.page = catchupQueryParams.page - 1;
    if (catchupQueryParams.page >= 0) {
      queryParams = queryParams.set('page', <any>catchupQueryParams.page);
    }

    if (catchupQueryParams.statuses && catchupQueryParams.statuses.length > 0) {
      queryParams = queryParams.set('contentStatus', <any>catchupQueryParams.statuses);
    }

    if (catchupQueryParams.type) {
      queryParams = queryParams.set('type', <any>catchupQueryParams.type);
    }

    if (catchupQueryParams.itemCount) {
      queryParams = queryParams.set('itemCount', <any>catchupQueryParams.itemCount);
    }

    if (catchupQueryParams.name) {
      queryParams = queryParams.set('name', <any>catchupQueryParams.name);
    }
    if (catchupQueryParams.guid) {
      queryParams = queryParams.set('guid', <any>catchupQueryParams.guid);
    }
    if (catchupQueryParams.status) {
      queryParams = queryParams.set('contentStatus', <any>catchupQueryParams.status);
    }
    if (catchupQueryParams.sortParam) {
      queryParams = queryParams.set('sortParam', <any>catchupQueryParams.sortParam);
    }
    if (catchupQueryParams.planStartTime) {
      queryParams = queryParams.set('planStartTime', <any>catchupQueryParams.planStartTime);
    }
    if (catchupQueryParams.planEndTime) {
      queryParams = queryParams.set('planEndTime', <any>catchupQueryParams.planEndTime);
    }
    if (catchupQueryParams.genreId) {
      queryParams = queryParams.set('genreId', <any>catchupQueryParams.genreId);
    }
    return this.http.get<PageOfCatchup>(this.catchupApiUrl + '/getcatchupswithplanprofile', {params: queryParams});
  }

  setCatchupRequest(catchupCreateReq: CatchupCreateRequest): Observable<CatchupCreateRequest> {
    return this.http.post<CatchupCreateRequest>(this.catchupApiUrl, catchupCreateReq);
  }

  getIngestStatus(catchupId: number): Observable<string> {
    return this.http.get(`${this.catchupApiUrl}/${catchupId}/ingest-status`, {responseType: 'text'});
  }

  updateCatchup(catchup: Catchup, updateChilds?: boolean,
                unpublishIfNotPublishable?: boolean): Observable<Catchup> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if (updateChilds) {
      queryParams = queryParams.set('updateChilds', <any>updateChilds);
    }
    if (unpublishIfNotPublishable) {
      queryParams = queryParams.set('unpublishIfNotPublishable', <any>unpublishIfNotPublishable);
    }
    return this.http.put<Catchup>(this.catchupApiUrl, catchup, {params: queryParams});
  }

  /** Dry-run before a parent change: does the move force the catchup to be unpublished? */
  precheckCatchupParent(catchupId: number, parentId: number): Observable<ParentChangePrecheck> {
    return this.http.get<ParentChangePrecheck>(
      `${this.catchupApiUrl}/${catchupId}/parent/${parentId}/precheck`);
  }

  setCatchupHidden(catchupId: number, enable: boolean): Observable<Catchup> {
    const queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()})
      .set('enable', <any>enable);

    return this.http.put<Catchup>(`${this.catchupApiUrl}/${catchupId}/hidden`, null, {
      params: queryParams,
    });
  }

  updateCatchupPromise(catchup: Catchup, isChildUpdate: boolean): Promise<Catchup> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if (isChildUpdate) {
      queryParams = queryParams.set('updateChilds', <any>isChildUpdate);
    }
    return this.http.put<Catchup>(this.catchupApiUrl, catchup, {params: queryParams}).toPromise();
  }

  getCatchupById(catchupId: number): Observable<Catchup> {
    return this.http.get<Catchup>(this.catchupApiUrl + `/${catchupId}`);
  }

  getLanguageOptions(catchupId: number): Observable<LanguageOption[]> {
    return this.http.get<LanguageOption[]>(this.catchupApiUrl + `/${catchupId}/languageoptions`);
  }

  addLanguageOptions(catchupId: number, request: LanguageOptionsRequest): Observable<any> {
    return this.http.post(this.catchupApiUrl + `/${catchupId}/languageoptions/add`, request, {
      responseType: 'text' as 'json',
    });
  }

  updateLanguageOptions(catchupId: number, request: LanguageOptionsRequest): Observable<any> {
    return this.http.put(this.catchupApiUrl + `/${catchupId}/languageoptions/update`, request, {
      responseType: 'text' as 'json',
    });
  }

  removeLanguageOptions(catchupId: number, request: LanguageOptionsRequest): Observable<any> {
    return this.http.request<any>('delete', this.catchupApiUrl + `/${catchupId}/languageoptions/remove`, {
      body: request,
      responseType: 'text' as 'json',
    });
  }

  resyncLanguageOptionsFromChannel(catchupId: number): Observable<any> {
    return this.http.post(this.catchupApiUrl + `/${catchupId}/languageoptions/resync-from-channel`, {}, {
      responseType: 'text' as 'json',
    });
  }

  getCatchupByIdPromise(catchupId: number): Promise<Catchup> {
    return this.http.get<Catchup>(this.catchupApiUrl + `/${catchupId}`).toPromise();
  }

  getChildContents(id: number): Observable<Catchup[]> {
    return this.http.get<Catchup[]>(this.catchupApiUrl + `/${id}/childs`);
  }

  setCatchupPosters(
    catchupId: number,
    posterDefinitionId: number,
    autoPosterCreation: boolean,
    updateChilds: boolean,
    file: File,
  ): Observable<Catchup> {
    let queryParams = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (autoPosterCreation) {
      queryParams = queryParams.set('autoPosterCreate', <any>autoPosterCreation);
    }
    if (updateChilds) {
      queryParams = queryParams.set('updateChilds', <any>updateChilds);
    }

    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file);
    }

    return this.http.post<Catchup>(this.catchupApiUrl + `/${catchupId}/posters/${posterDefinitionId}/upload`, formData, {
      params: queryParams,
      responseType: 'text' as 'json',
    });
  }

  approveCatchupContent(id: number, platform: string): Observable<any> {
    return this.http.get<any>(this.catchupApiUrl + `/${id}/${platform}/approve`);
  }

  setPosterWithoutCatchup(posterDefinitionId: number, autoPosterCreate: boolean, file: File): Observable<any> {
    let queryParams = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (autoPosterCreate != undefined && autoPosterCreate != null && autoPosterCreate) {
      queryParams = queryParams.set('autoPosterCreate', <any>autoPosterCreate);
    }
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.catchupApiUrl + `/posters/${posterDefinitionId}/upload`, formData, {
      params: queryParams,
    });
  }

  copyProgramPosterToTemp(posterDefinitionId: number, programPosterUrl: string): Observable<any> {
    let queryParams = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    queryParams = queryParams.set('programPosterUrl', programPosterUrl);
    return this.http.post<any>(this.catchupApiUrl + `/posters/${posterDefinitionId}/copyFromProgram`, null, {
      params: queryParams,
    });
  }

  trimCatchup(catchupId: number, trimRequestModel?: CatchupTrimRequest): Observable<Catchup> {
    return this.http.put<Catchup>(this.catchupApiUrl + `/${catchupId}/trim`, trimRequestModel, {responseType: 'text' as 'json'});
  }

  trimCatchupPromise(catchupId: number, trimRequestModel?: CatchupTrimRequest): Promise<Catchup> {
    return this.http.put<Catchup>(this.catchupApiUrl + `/${catchupId}/trim`, trimRequestModel).toPromise();
  }

  publishCatchup(catchupId: number): Observable<Catchup> {
    return this.http.get<Catchup>(this.catchupApiUrl + `/${catchupId}/publish`, {responseType: 'text' as 'json'});
  }

  unPublishCatchup(catchupId: number): Observable<Catchup> {
    return this.http.get<Catchup>(this.catchupApiUrl + `/${catchupId}/unpublish`, {responseType: 'text' as 'json'});
  }

  createContentByCatchup(catchupId: number, request?: CreateCatchupVodRequest): Observable<string> {
    return this.http.post(this.catchupApiUrl + `/${catchupId}/createcontent`, request || null, {responseType: 'text'});
  }

  createFromEpgProgram(
    program: Program,
    generatedSeriesId: string,
    allowDuplicateFromSameEpg?: boolean,
    migrated?: boolean
  ): Observable<Program> {
    let queryParam = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (generatedSeriesId) {
      queryParam = queryParam.set('generatedSeriesId', <any>generatedSeriesId);
    }
    if (allowDuplicateFromSameEpg) {
      queryParam = queryParam.set('allowDuplicateFromSameEpg', <any>allowDuplicateFromSameEpg);
    }
    if (migrated) {
      queryParam = queryParam.set('migrated', <any>migrated);
    }
    return this.http.post<Program>(this.catchupApiUrl + `/createfromepgprogram`, program, {
      params: queryParam,
      responseType: 'text' as 'json'
    });
  }

  deleteCatchup(catchupId: number): Observable<number> {
    return this.http.delete<number>(this.catchupApiUrl + `/${catchupId}`);
  }

  getCatchupMetadataHistory(catchupId: number): Observable<ContentMetadataHistory> {
    return this.http.get<ContentMetadataHistory>(this.catchupApiUrl + `/${catchupId}/metadata/history`);
  }

  getInProgressCuTVCount(): Observable<number> {
    return this.http.get<number>(this.catchupApiUrl + `/inprogresscutv/count`);
  }

  catchupStatusLog(catchupId: number): Observable<StatusLog[]> {
    return this.http.get<StatusLog[]>(this.catchupApiUrl + `/${catchupId}/catchupstatuslogs`);
  }

  // Get Catchup Notes
  getCatchupNotes(catchupId: number, page?: number, itemCount?: number): Observable<PageOfCatchupNote> {
    let queryParams: HttpParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    page = page - 1;
    if (page > -1) {
      queryParams = queryParams.set('page', <any>page);
    }
    if (itemCount) {
      queryParams = queryParams.set('itemCount', <any>itemCount);
    }

    return this.http.get<PageOfCatchupNote>(this.catchupApiUrl + `/${catchupId}/notes`, {params: queryParams});
  }

  // Add Catchup Notes
  addCatchupNote(noteObj: CatchupNote, id: number): Observable<CatchupNote> {
    return this.http.post<CatchupNote>(this.catchupApiUrl + `/${id}/notes`, noteObj, {responseType: 'text' as 'json'});
  }

  //Delete Catchup Note
  deleteCatchupNote(id: number): Observable<string> {
    return this.http.delete<string>(this.catchupApiUrl + `/${id}/notes`, {
      responseType: 'text' as 'json',
    });
  }

  //Edit Catchup Note
  editCatchupNote(noteObj: CatchupNote): Observable<CatchupNote> {
    return this.http.put<CatchupNote>(this.catchupApiUrl + `/notes`, noteObj, {responseType: 'text' as 'json'});
  }

  getNotApprovedCatchups(
    page?: number,
    itemCount?: number,
    sortParam?: string[],
    catchupsIssueTypes?: string[],
  ): Observable<PageOfNotApprovedCatchupResponse> {
    let queryParam = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (page > -1) {
      queryParam = queryParam.set('page', <any>page);
    }
    if (itemCount) {
      queryParam = queryParam.set('itemCount', <any>itemCount);
    }
    if (catchupsIssueTypes) {
      queryParam = queryParam.set('issueTypes', <any>catchupsIssueTypes);
    }
    if (sortParam) {
      queryParam = queryParam.set('sortParam', <any>sortParam);
    }

    return this.http.get<PageOfNotApprovedCatchupResponse>(this.catchupApiUrl + `/notapproved`, {params: queryParam});
  }

  checkApprovedStatus(catchupId: number): Observable<string> {
    return this.http.get<string>(this.catchupApiUrl + `/${catchupId}/checkapprovedstatus`);
  }

  validationRecheck(catchupId: number): Observable<any> {
    return this.http.post<any>(this.catchupApiUrl + `/${catchupId}/validation/recheck`, null, {responseType: 'text' as 'json'});
  }

  validationCheck(catchupId: number, platformComments: ValidationEventsPlatformComment[]): Observable<any> {
    return this.http.post<any>(this.catchupApiUrl + `/${catchupId}/validation/check`, platformComments, {responseType: 'text' as 'json'});
  }

  rescueCatchup(catchupId: number): Observable<string> {
    return this.http.get<string>(this.catchupApiUrl + `/${catchupId}/undo`);
  }

  notifyCatchupDeleted() {
    this.catchupDeletedSource.next();
  }

  setSection(catchupId: number, contentSectionInfoRequest?: ContentSectionInfoRequest): Observable<string> {
    return this.http.post<string>(this.catchupApiUrl + `/${catchupId}/section`, contentSectionInfoRequest, {responseType: 'text' as 'json'});
  }

  getNextAndPrevCatchups(catchupId: number): Observable<number[]>{
    return this.http.get<number[]>(this.catchupApiUrl + `/${catchupId}/getNextAndPrevCatchup`);
  } 

  addCensorshipPreview(catchupId: number, censorship: CensorshipPreview, updateChilds?: boolean): Observable<string> {
    let queryParams = new HttpParams();
    if (updateChilds) {
      queryParams = queryParams.set('updateChilds', <any>updateChilds);
    }
    return this.http.post<string>(this.catchupApiUrl + `/${catchupId}/censorshippreview`, censorship, {
      params: queryParams,
      responseType: 'text' as 'json',
    });
  }

  updateCensorshipPreview(catchupId: number, censorship: CensorshipPreview): Observable<string> {
    return this.http.put<string>(this.catchupApiUrl + `/${catchupId}/censorshippreview`, censorship, { responseType: 'text' as 'json' });
  }

  getCensorshipPreviewHistory(catchupId: number, page: number, itemCount: number): Observable<any> {
    let queryParam = new HttpParams();
    queryParam = queryParam.set('page', page.toString());
    queryParam = queryParam.set('itemCount', itemCount.toString());
    return this.http.get<any>(this.catchupApiUrl + `/${catchupId}/censorshippreview/history`, { params: queryParam });
  }

  searchParents(text: string, childType: string): Observable<Catchup[]> {
    return this.http.get<Catchup[]>(this.catchupApiUrl + `/parentsearch`, {
      params: { text, childType }
    });
  }

  getChildCount(catchupId: number): Observable<number> {
    return this.http.get<number>(this.catchupApiUrl + `/${catchupId}/childs/count`);
  }
}
